import { cellTone, TONE_STYLES } from '../calendar/utils';

export { cellTone, TONE_STYLES };

const HUES = ['#7E5BD0', '#C0598E', '#E07866', '#D9A23F', '#3FA784', '#3F6FD6'];

export function hueFor(name: string): string {
  return HUES[(name.charCodeAt(0) + name.length) % HUES.length] ?? '#7E5BD0';
}

export function formatMoney(n: number): string {
  return '$' + n.toLocaleString();
}

export const BADGE_TONE_COLOR: Record<string, string> = {
  success: 'var(--success)',
  gold: 'var(--gold)',
  danger: 'var(--terracotta)',
  neutral: 'var(--ink-3)',
};
